<div class="layout-col full">
  <!-- Toolbar -->
  <mat-toolbar color="primary" class="gap-md">
    <button mat-icon-button (click)="close($event)">
      <mat-icon>close</mat-icon>
    </button>

    <elder-header
      [header]="'positions.transfer' | translate"
      [subheader]="('orders.prod.order' | translate) + ': ' + orderA.prodOrderId"
    >
    </elder-header>
  </mat-toolbar>

  <div class="flex layout-col p-lg">
    <div class="flex layout-row gap-md">
      <!-- work order A -->
      <div class="flex layout-col gap-md">
        <div class="layout-row gap-md">
          <mat-form-field>
            @if (orderA$ | async; as orderA) {
              <mat-hint>{{ this.hintResolverFn(orderA) }}</mat-hint>
            }
            <elder-select
              name="workOrderA"
              appWorkOrderSelect
              [placeholder]="'orders.work.order' | translate"
              [prodOrderId]="orderA.prodOrderId"
              [(ngModel)]="orderA"
            >
              <div *elderSelectValue="let value" class="layout-col text-body-medium">
                <span>{{ value.id }}</span>
                <span>{{ value.facility }}/{{ value.collectingFacility }}</span>
              </div>
            </elder-select>
          </mat-form-field>

          @if (contextA$ | async; as ctx) {
            <app-work-order-header [workOrder]="ctx.order" [overview]="ctx.overview">
            </app-work-order-header>
          }
        </div>

        @if (contextA$ | async; as ctx) {
          <div class="flex layout-row">
            <app-work-item-table
              class="flex"
              [workOrder]="ctx.order"
              [allowEdit]="false"
              [selectEnabled]="true"
              [interactionMode]="'selection'"
              [involvedProcessPlanIds]="ctx.involvedProcessPlanIds"
              [selectableEvaluatorFn]="getSelectableEvaluatorFn()"
              (selectionChange)="selectionA = $event"
            >
            </app-work-item-table>
          </div>
        }
      </div>

      <!-- transfer controls -->
      <div class="layout-col place-center-center gap-xl">
        <button mat-icon-button (click)="transferAtoB()" [disabled]="!canTransferAtoB">
          <mat-icon class="rotate-90">arrow_circle_up</mat-icon>
        </button>

        <button mat-icon-button (click)="transferBtoA()" [disabled]="!canTransferBtoA">
          <mat-icon class="rotate-90">arrow_circle_down</mat-icon>
        </button>
      </div>

      <!-- work order B -->
      <div class="flex layout-col">
        <div class="layout-row gap-md">
          <mat-form-field>
            @if (orderB$ | async; as orderB) {
              <mat-hint>{{ this.hintResolverFn(orderB) }}</mat-hint>
            }
            <elder-select
              name="workOrderB"
              appWorkOrderSelect
              [placeholder]="'orders.work.order' | translate"
              [workOrderFilters]="orderBSelectFilter$ | async"
              [excludeIds]="[(orderA$ | async)?.id]"
              [(ngModel)]="orderB"
            >
              <div *elderSelectValue="let value" class="layout-col text-body-medium">
                <span>{{ value.id }}</span>
                <span> {{ value.facility }}/{{ value.collectingFacility }} </span>
              </div>
            </elder-select>
          </mat-form-field>

          @if (contextB$ | async; as ctx) {
            <app-work-order-header [workOrder]="ctx.order" [overview]="ctx.overview">
            </app-work-order-header>
          }
        </div>

        @if (contextB$ | async; as ctx) {
          <app-work-item-table
            class="flex"
            [workOrder]="ctx.order"
            [allowEdit]="false"
            [selectEnabled]="true"
            [interactionMode]="'selection'"
            [involvedProcessPlanIds]="ctx.involvedProcessPlanIds"
            [selectableEvaluatorFn]="getSelectableEvaluatorFn()"
            (selectionChange)="selectionB = $event"
          >
          </app-work-item-table>
        }
      </div>
    </div>
  </div>
</div>
